module.exports = __webpack_public_path__ + "static/media/2016_conf_So_You_Want_to_be_a_Service_Designer.38b8def0.png";